export const en = {
  translation: {
    global: {
      emptySubtitle: "There's no available data to show.",
      loadingProfile: "Loading profile",
      initializingProfileTitle: "Please wait.",
      initializingProfileSubtitle: "We are collecting your information.",
      slowConnectionTitle: "Still Loading",
      slowConnectionSubtitle: "Please wait we are experiencing slow connection",
      loadingResetView: "Resetting the call view",
      errors: {
        unauthorized: "You are not authorized to access this page.",
      },
      peopleCount: "{{count}}", // used to include the kanji for people count
      button: {
        add: "Add",
        edit: "Edit",
        submit: "Submit",
        save: "Save",
        update: "Update",
        login: "Login",
        logout: "Logout",
        skip: "Skip",
        accept: "Accept",
        acceptInbound: "Accept",
        endCall: "End Call",
        hold: "Hold",
        resume: "Resume",
        mute: "Mute",
        unmute: "Unmute",
        endTask: "Next contact",
        confirmAndGoNext: "Confirm and Go Next",
        confirmAndGoOffline: "Confirm and Go Offline",
        call: "Call",
        addStatus: "Add Status",
        cancel: "Cancel",
        loading: "Loading",
        savingReport: "Saving report",
        resetPassword: "Request new password",
        refreshPage: "Refresh page",
        showMore: "Show more",
        showLess: "Show less",
        goBack: "Go back",
        close: "Close",
        download: "Download",
        upload: "Upload",
        moreActions: "More",
        apply: "Apply",
        wontCall: "Won't call",
        confirm: "Confirm",
        confirmAndReturn: "Confirm and return",
        clickToCopy: "Click to copy",
        copied: "Copied!",
      },
      search: {
        action: "Search",
        noItemsFound: "No items found",
        selectedValues: "{{count}} selected",
      },
      modals: {
        skipTask: {
          title: "Are you sure you want to skip?",
          description: "This student will be moved to the end of the queue.",
        },
        abandonCallReport: {
          title: "Are you sure you want to abandon the call report?",
          description: "All changes will be lost.",
        },
        goOffline: {
          title: "You have a call in progress",
          submitDescription:
            "Are you sure you want to submit the call report and go offline?",
          skipDescription:
            "Are you sure you want to skip this call and go offline?",
          callError: "You can't go offline while you have a call in progress.",
        },
        redirect: {
          title: "You must be Offline to view this page.",
          description:
            "If you want to visit this page, please go back and set yourself Offline first. This may require skipping the current call.",
        },
        microphoneNotShared: {
          title: "Please connect your microphone",
          win: {
            subtitle: "Windows only",
            button: "Windows only",
            text: [
              "Click the speaker icon in the bottom right of the taskbar.",
              "Click 'Open Volume Mixer'.",
              "A list of available audio output devices will appear. Select the device you want to use for all system sounds, including Chrome.",
            ],
          },
          mac: {
            subtitle: "Mac only",
            button: "Mac only",
            text: [
              "Click the Apple menu in the top left of the screen.",
              "Click 'System Preferences'.",
              "Click 'Sound'.",
              "Click the 'Output' tab. Select the desired audio output device from the list.",
            ],
          },
        },
        browserError: {
          title: "Your browser is not supported, so calls cannot be made.",
          text: [
            "Calliope is not supported on your current browser.",
            "To make calls, please use Google Chrome, Microsoft Edge, or Mozilla Firefox.",
          ],
        },
        manualCallLeaveConfirm: {
          title: "Do you want to leave the page and end the call?",
          description:
            "Leaving the page will end the call. In this case, the student's status and call schedule will be kept up to date.",
          confirmation: "Are you sure you want to leave this page?",
          submit: "Leave the page and end the call",
        },
        manualCallFinisher: {
          title: "Unfinished Call Detected",
          description: "Unfinished work detected, we will clean up for you...",
          submit: "Done",
        },
      },
      datepicker: {
        placeholder: "Select a date",
        rangePlaceholder: "Select a date range",
        timeLabel: "Time",
        today: "Today",
        thisWeek: "This week",
        last7days: "Last 7 days",
        thisMonth: "This month",
        last30days: "Last 30 days",
      },
    },
    sidebarMenu: {
      callPanel: "Call Panel",
      campaigns: "Campaigns",
      noCallList: "NG List",
      performance: "Performance",
      users: "Staff",
      missedCalls: "Missed Calls",
    },
    header: {
      admin: "Admin",
      agent: "Agent",
      callCenterManager: "Call Center Manager",
      callCenterManagerAndAgent: "Call Center Manager and Agent",
      qualityAnalyst: "Quality Analyst",
      agentSelectOptions: {
        online: "Available",
        offline: "Offline",
        loading: "Initializing",
      },
      language: "Language",
      logout: "Logout",
      editProfile: {
        menuItem: "Edit",
        title: "Edit Profile",
        error: "Unable to update your profile.",
      },
      diagnoseIssue: {
        button: "Open Diagnosis Page",
        title: "Diagnose Issue",
        description:
          "Sending diagnostic results to the support team helps us better understand the situation and provide a smoother resolution.",
        instruction: {
          title: "How to Run the Diagnosis",
          one: "1. Click the button below to open the diagnosis page.",
          two: "2. When the page opens, allow access to user information (see top-right image). You need to allow the following three permissions: Location access, Microphone use and Camera use.",
          three:
            '3. The diagnosis will begin automatically. Once it’s complete, click "Download results" to download the test results (see bottom-right image).',
          four: "4. Please upload the downloaded file to Slack and send it to the support team.",
        },
      },
    },
    campaigns: {
      list: {
        title: "Campaigns",
        name: "Name",
        studentCount: "Student Count",
        studentsToBeCalled: "To be called today",
        status: "Status",
        create: "Create",
        warning: {
          phoneNumber: "Duplicate phone number",
        },
      },
      search: {
        inactiveInclude: "Show inactive/closed campaigns",
      },
      details: {
        viewList: "View list",
        lastUpdate: "Last update",
        currentNumbers: "Student numbers",
        viewStatuses: "View statuses",
        exportCSV: {
          action: "Export to CSV",
          loading: "Preparing your CSV file...",
          success: "Click on the following link to download the CSV file:",
          download: "Download CSV",
        },
        importCSV: {
          action: "Import entries CSV file",
          errorRow: "Row {{row}}: {{message}}",
          errorRowColumn: "Row {{row}}, column {{column}}: {{message}}",
        },
        search: {
          universities: "All universities",
          statuses: "All statuses",
        },
        students: {
          name: "Name",
          email: "Email",
          contactDate: "Contact Date",
          contactCount: "Number of Contacts",
          currentStatus: "Latest status",
          comment: "Comment",
        },
        actions: {
          editComment: {
            label: "Edit History",
            success: "The history was edited successfully.",
            error: "Unable to edit the history",
          },
        },
      },
      edit: {
        breadcrumb: "Edit",
      },
      create: {
        title: "New campaign",
        breadcrumb: "Create",
        queuePlaceholder: "Select a queue",
        errors: {
          MISSING_OUTBOUND_CALLER_NUMBER_ID:
            "This queue is missing an outbound caller number",
          INVALID_NAME:
            "Invalid queue name, special characters are not allowed",
        },
      },
      statuses: {
        active: { label: "Active" },
        paused: { label: "Paused" },
        closed: { label: "Closed" },
      },
      actions: {
        pause: "Pause",
        resume: "Activate",
        close: "Close",
      },
      dialogs: {
        error: "Unable to change the status of the campaign",
        pause: {
          title: "Pause campaign",
          description:
            "Confirming this action will immediately stop all outgoings related to the campaign",
          confirm: "Are you sure you want to pause this campaign?",
          success: "The campaign has been successfully paused.",
        },
        resume: {
          title: "Activate campaign",
          confirm: [
            "Are you sure you want to activate this campaign?",
            "This process may take a long time, especially if multiple campaigns are being stopped or started.",
            "Please click the refresh button to see the current status.",
          ],
          success: "The campaign has been successfully activated.",
        },
        close: {
          title: "Close Campaign",
          description:
            "The closed campaign will be removed from Amazon Connect. You will no longer be able to make calls or resume this campaign.",
          callHistoryNote:
            "Call history and performance metrics linked to the campaign will be retained and remain accessible.",
          limitNote:
            "(This feature is primarily used when the number of campaigns that can be created in Amazon Connect has reached its limit.)",
          confirm: "Are you sure you want to close this campaign?",
          success: "The campaign has been successfully closed.",
        },
        statusUpdate: {
          addTitle: "Append Status",
          addButton: "Append",
          successDescription: "New status was appended successfully.",
          failedDescription: "Unable to append the new status.",
        },
      },
      filters: {
        title: "Filters",
        add: {
          short: "Add",
          long: "Add filter",
          smartFilters: "Smart filters",
          basicFilters: "Basic filters",
          manualAdditions: "Manual Additions",
        },
        shortSummary: "{{label}} ({{count}})",
        channels: {
          label: "QA Channels",
          short: "Channel",
          placeholder: "Pick a channel",
          add: "Add channel",
          remove: "Remove channel",
          operators: {
            and: "AND",
            or: "OR",
            "except-for": "None",
          },
          apply: "Apply filters",
        },
        university: {
          label: "University",
          selectedFilters: "{{count}} filters",
          list: "University List",
          group: "Groups",
          include: "Include",
          exclude: "Exclude",
        },
        graduation_year: {
          label: "Graduation Year",
        },
        major: {
          label: "Major",
        },
        selected_phone_numbers: {
          label: "Phone Numbers",
          header: "Add Students Manually",
          explanation:
            "Enter phone numbers to manually add students to the campaign.",
          details: [
            "If you want to add multiple students at once, enter one phone number per line.",
            "Use half-width numeric characters and hyphens only.",
          ],
          submit: "Preview",
          errors: {
            DUPLICATE: "Duplicate phone number",
            INVALID_PHONE_NUMBER: "Invalid input format",
            NOT_FOUND: "No matching students found",
          },
          preview: {
            header: "Students preview",
            noStudentsFound: "No students found!",
            found: "students will be added to the filter",
            errors:
              "items have errors. Errors will not be reflected in the filter",
            onlyErrors: "Show errors only",
          },
        },
        department_group: { label: "Department" },
        gender: { label: "Gender" },
        selected: "{{propertyName}}: {{count}} selected",
        question: {
          placeholder: "Pick a question",
        },
        answer: {
          placeholder: "Pick an answer",
        },
        noFilterSelected: "None",
        success: "Campaign saved successfully",
      },
      priorityFilters: {
        title: "Priority Filters",
        warningNoFilters: "Please select filters first",
      },
      preview: {
        table: {
          title: "{{count}} students found",
          noResults: "No students found",
          lastName: "Last Name",
          firstName: "First Name",
          phoneNumber: "Phone Number",
          channels: "QA Channels",
          university: "University",
          department: "Department",
          major: "Major",
          graduationYear: "Graduation Year",
          gender: "Gender",
          limitExceed: {
            title:
              "The maximum number of students that can be added to the campaign ({{count}}) has been exceeded.",
            description:
              "Please adjust the filtering criteria to reduce the number of applicable students.",
          },
        },
        emptyState: "Add filters to see the list of students",
      },
    },
    entries: {
      title: "Entries Management",
      upload: {
        title: "Add More Entries",
        panelTitle: "To add multiple results, please follow the steps below:",
        instruction1: "Download this template",
        instruction2:
          "Edit the additional files according to the following steps:",
        stepText1: "Enter the student's phone number",
        stepText2: "Input the result of the entry from below:",
        instruction3: "Upload this CSV file",
        noFilePlaceholder: "No file upload",
        uploadButtonText: "Upload File",
        cancelButtonText: "Cancel and Return to the List",
        confirmButtonText: "Confirm Upload",
        modal: {
          errorTitle: "Errors found ({{count}})",
          successTitle: "No errors!",
          successDescription:
            "{{count}} entry result(s) have been updated. To see the updated student information, please go to the student information list.",
        },
      },
    },
    performance: {
      export: {
        csvDownload: "Download CSV",
        confirmTitle: "Please Confirm Before Downloading",
        dateSelectText: "Select Date for Downloading",
        campaignConfirmText: "Selected Campaign",
        allCampaigns: "All Campaigns will be selected",
        note: "Note",
        noteText: "The download campaign data includes the following:",
        downloadRequestButton: "Request Download",
        downloadButton: "Download",
        loadingTitle: "Preparing...",
        loadingDescription:
          "CSV file is being prepared. Please wait for a moment.",
        successTitle: "Prepared for Download",
        successDescription:
          "The CSV file is ready for download. Please click the button below to download.",
      },
      tabs: {
        campaign: "Campaigns",
        staff: "Staff",
        personal: "Personal",
      },
      placeholder: {
        search: "Search",
      },
      table: {
        cacheTips: "Metrics updated at {{time}}, auto refresh every 5 mins",
        campaignName: "Campaign Name",
        agentName: "Name",
        deletedUser: "[User Deleted]",
      },
      detail: {
        agentTitle: "Staff Performance",
        campaignTitle: "Campaigns Detail",
        callsPerHour: "Calls Per Hour",
        creditForEntryConfirmedCVR: "Credit for Entry Confirmed CVR",
        totalProcessingTime: "Total Processing Time",
      },
      error: {
        invalidFormat: "There was a problem displaying the data",
      },
    },
    syncAgents: {
      description:
        "To synchronize with the Amazon connect database and update your staff information, click the button below.",
      buttonText: "Sync Agents",
      syncing: "Syncing...",
      success: "Agents have been successfully synchronized",
      error: "Failed to synchronize agents",
      latestUpdateAt: "Latest Updated: {{date}}",
    },
    users: {
      list: {
        name: "Name",
        email: "Email",
        role: "Role",
        queues: "Campaigns",
        status: "Status",
        createdAt: "Created",
        updatedAt: "Last Update",
        missingRole: {
          label: "No role",
          tooltip:
            "This user has no role assigned. Run Sync Agents to assign one.",
        },
      },
      statuses: {
        CONFIRMED: "Confirmed",
        FORCE_CHANGE_PASSWORD: "Password Reset",
        RESET_REQUIRED: "Reset Required",
        NOT_FOUND: "Not Found, sync needed",
        DELETED: "Deleted",
      },
      groups: {
        // Mapping from Cognito group names
        Agent: "Agent",
        Manager: "Manager",
      },
      edit: {
        title: "Edit User",
        routingProfile: "Routing Profile",
        success: "User {{name}} has been successfully updated.",
      },
      resendPassword: {
        action: "Resend Password",
        confirm:
          "Are you sure you want to resend the password to the following email address?",
        success: "Temporary password sent to {{email}}.",
      },
    },
    dashboard: {
      title: "Metrics",
      tabs: {
        performance: "Performance",
        statuses: "Status",
      },
      csv: {
        exportAction: "Export to CSV",
        exportLoading: "Preparing CSV...",
        downloadAction: "Download CSV",
      },
      selectOptions: {
        values: {
          allStaff: "All Staff",
        },
        labels: {
          staffPerformance: "Staff Performance",
          campaignPerformance: "Campaign Performance",
        },
        searchPlaceholder: "Search",
        selectPlaceholder: "Select",
      },
      table: {
        header: {
          lastName: "Last Name",
          firstName: "First Name",
          numberOfCalls: "Number of Calls",
          connectedCalls: "Connected Calls",
          entries: "Entries",
          actualEntries: "Actual entries",
          login: "Login",
          ringTime: "Ring Time",
          talkTime: "Talk Time",
          operation: "Operation",
          grandTotal: "Total",
          totalNumber: "Total",
          totalTime: "Total",
          hourly: "Hourly",
          average: "AVG",
          rate: "Rate",
        },
        values: {
          hours: "hours",
        },
      },
    },
    ids: {
      taskId: "Task ID:",
      voiceId: "Voice ID:",
      uuid: "UUID:",
    },
    callPanel: {
      title: "Student Information",
      incomingCall: "Incoming Call",
      loading: {
        waitingForTask: "Preparing for the next call.",
        fetchingData: "Fetching student data...",
        inboundCall: "Inbound Call",
        interruptedByInboundCall: [
          "The previous student",
          "will go back after the inbound call...",
        ],
      },
      emptyQueue: {
        subtitle: "Thank you for your hard work!",
        cardTitle: "Today's call work is over.",
        cardText:
          "Please set your status to offline before turning off your computer.",
      },
      resetState: {
        title: "An unexpected error has occurred",
        subtitle: "Please refresh the page to continue.",
      },
      invalidAgentConfig: {
        title: "No campaigns found",
        description: [
          "We couldn't find the campaign assigned to you.",
          "Please contact your manager and ask them to assign campaign to you again.",
        ],
      },
      status: {
        connecting: "Connecting",
        error: "Error",
        missedCall: "Missed Call",
        missedCallAgentState: "Call connection issue: network or microphone",
        missedTask: "Missed Task",
        rejectedCall: "Call rejected",
        connected: "Connected",
        acw: "Call Result",
        skipped: "Skipped",
      },
      report: {
        title: "Call Status Editing",
      },
      phoneNumber: "Phone Number",
      reason: {
        invalidQueueARN:
          "Cannot make outbound call due to configuration issue of the system.",
        disabledCampaign:
          "You cannot call this student because the campaign is disabled.",
      },
      idle: {
        heading:
          "Operation has been stopped due to inactivity for a certain period",
        body: [
          "Operation has been temporarily stopped because there was no activity for more than {{minutes}} minutes. The time elapsed during this period will not be counted as processing time.",
          `To return to work, please click "Resume Work."`,
        ],
        button: "Resume Work",
      },
      callErrorCard: {
        networkError: {
          title: "Network Error",
          description: [
            "A network error occurred.",
            "If the issue persists, please try the following solutions:",
            [
              "Refresh the page",
              "Restart the browser",
              "Restart your computer",
            ],
            "If the issue still persists, please force-refresh the page using the button below.",
            "Note that any call results you have entered will be lost when performing a force refresh.",
          ],
        },
        browserError: {
          title: "Browser not supported",
          description: [
            "Calliope is not supported on your current browser.",
            "To make calls, please use Google Chrome, Microsoft Edge, or Mozilla Firefox.",
          ],
        },
        micPermissionError: {
          title: "Microphone Connection Error",
          description: [
            "Please connect a microphone to your PC to continue making calls.",
          ],
          button: "Open Instructions",
        },
        unexpectedError: {
          title: "An unexpected error",
          description: [
            "An unexpected error occurred.",
            "If the issue persists, please try the following solutions:",
            [
              "Refresh the page",
              "Restart the browser",
              "Restart your computer",
            ],
          ],
        },
        missedCallNetworkError: {
          title: "Connection Error",
          description: [
            "A connection error occurred, and the call was terminated.",
            "Please enter the call result and save it, or return to the previous screen and make the call again by clicking 'Go back.'",
          ],
        },
        submitError: {
          title: "Failed to switch to the next contact",
          description:
            "Please try again and reload the page if it happens again.",
        },
      },
      reportErrorCard: {
        scheduledCallDateTimeTooSmall: {
          title: "Invalid call report date",
          description: [
            "The date and time of the call report is too far in the past.",
            "Please set a correct date and time.",
          ],
        },
        scheduledCallDateTimeTooBig: {
          title: "Invalid call report date",
          description: [
            "The date and time of the call report is too far in the future.",
            "Please set a correct date and time.",
          ],
        },
        otherValidationError: {
          title: "Call report data validation error",
          description: [
            "The data submitted for the call report is invalid.",
            "Please check the form data and try again.",
          ],
        },
      },
    },
    caseHistory: {
      entorId: "Entor ID",
      legacyId: "Old Entor ID",
      nameFurigana: "Furigana",
      university: "University",
      department: "Department",
      graduation: "Graduation Year",
      question: "What was my focus as a student?",
      agent: "Agent",
      campaign: "Campaign",
      agentName: "Staff Name",
      callStatus: "Current call status",
      contactHistory: "Contact history of all campaigns",
      email: "Email",
      applicationDate: "Application Date",
      applicationRoute: "Channel",
      syncQA: "Sync Q&A",
      refreshUpdated: "Student questions and answers updated",
      refreshUpToDate: "Student questions and answers already up to date",
      refreshError: "Failed to refresh Q&A data",
      hiddenStatus: {
        scheduled: "Scheduled",
        renewed: "Renewed",
        recovery: "Recovery",
      },
      tabs: {
        history: "History",
        numberOfItems: "Entries {{count}}",
        detailedInformation: "Detailed Information",
      },
      activityFeed: {
        staff: "Agent",
        comments: "Memo",
        lastUpdate: "Last Update",
        nextCall: "Next Call",
        status: "Status",
        callType: {
          label: "Call Type",
          values: {
            noCall: "No Call",
            outbound: "Outbound Call",
            inbound: "Inbound Call",
          },
        },
      },
    },
    sidePanelMetrics: {
      open: "Today",
      title: ["Your Metrics", "Today"],
      description: [
        "The data is based only on the campaign you are currently working on",
        "Here's the campaign list you are assigned to now:",
      ],
      callsPerHour: "Calls/h",
      connectedCalls: {
        perHour: "CC/h",
        rate: "CC Rate",
      },
      conversions: {
        total: "CV",
        rate: "CVR",
      },
      entries: {
        total: "Entries",
        rate: "Entry Rate",
      },
    },
    callResult: {
      title: "Call Result",
      status: "Status",
      reason: "Reason",
      scheduleCall: "Schedule a follow-up call",
      memo: "Memo",
      placeholder: "Type here",
      success: "Call result submitted successfully",
      pcrTitle: "Status Update",
      groups: {
        out: "Out",
        callAgain: "Call Again",
      },
    },
    callHistory: {
      heading: "Call History",
      searchPlaceholder: "Search name",
      agentsFilterPlaceholder: "All staff",
      campaignsFilterPlaceholder: "All campaigns",
      tabs: {
        myCalls: "My Calls",
        allCalls: "Calls from All Agents",
      },
      duration: "Duration",
      recording: {
        retrieveFailure:
          "It may take a while for our service to process the audio recording. Please try again later.",
        transcript: {
          title: "Transcript",
          toggle: "Transcript",
          autoScroll: "Auto Scroll",
        },
      },
      role: {
        agent: "Agent",
        student: "Student",
      },
    },
    missedCalls: {
      heading: "Missed Calls",
      subHeading:
        "Shows unhandled missed calls from the past 2 weeks for cases you have previously called.",
      filterPlaceholder: "All campaigns",
      cellHeading: {
        name: "Name",
        entorId: "Entor ID",
        legacyId: "Legacy Entor ID",
        status: "Status",
        updatedAt: "Updated At",
        campaign: "Campaign",
        memo: "Memo",
      },
      emptyState: "There are no missed inbound calls.",
      dataLoadingError: "Unable to load missed inbound calls list",
    },
    login: {
      emailLabel: "Email",
      emailPlaceholder: "name@domain.com",
      passwordLabel: "Password",
      passwordPlaceholder: "password",
      subtitle: "Login to your account",
      help: "Need help?",
      contactManager: "Please contact the manager.",
      forgotPassword: "Forgot your password?",
      loadingText: "Verifying information",
    },
    resetPassword: {
      request: {
        title: "Forgot your password?",
        subtitle:
          "Enter your email in the form below. A link to reset your password will be delivered to your email address.",
        loadingText: "Verifying information",
        success:
          "An email has been sent to your inbox with instructions to reset your password.",
        tryAgain: "Didn't get an email?",
      },
      confirm: {
        title: "Set a new password",
        subtitle: "Please set a password following the rules below.",
        bulletPoints: [
          "Password must be at least 8 characters long",
          "Use uppercase and lowercase letters",
          "Do not use spaces",
          "Include at least one of the following characters",
        ],
        subBulletPoints: ["Numbers", "Special characters"],
        confirmPasswordLabel: "Password (confirm)",
        loadingText: "Verifying information",
        success: "Password has been successfully updated.",
      },
    },
    updateCheckerNotification: {
      title: "An application update is available!",
      description: "Click on Update button to reload the window.",
      ignore: "Later",
      update: "Update now",
    },
    noCallList: {
      columns: {
        actions: "Actions",
        updatedAt: "Last Update",
      },
      removeStudent: {
        confirmTitle: "Remove from NG list",
        confirmDescription:
          "Are you sure you want to remove this student from the NG list? This will allow them to be contacted again.",
        confirmAction: "Remove",
        cancel: "Cancel",
        error: "Failed to remove student from NG list.",
        success: "Student removed from NG list.",
        warnings: {
          TASK_NOT_FOUND:
            "Student removed from NG list, but a scheduled call task could not be found for this student",
          CASE_NOT_FOUND:
            "Student removed from NG list, but no case was found for this student",
          INTERNAL_ERROR:
            "Student removed from NG list, but related records could not be updated due to a system error",
        },
      },
      importCSV: {
        action: "Upload CSV",
        intro: "Upload a CSV file to update the NG list.",
        step1: "Download the template",
        step2: "Edit the file with the following details",
        details: [
          "Enter the phone number in the first column, the email address in the second column.",
          "Enter TRUE in the No Call column for students you want to add to the NG list.",
          "Enter FALSE in the No Call column for students you want to remove from the NG list.",
        ],
        step3: "Pick the CSV to upload",
        explanations: "Errors will be shown in the next screen",
        globalError: "Unable to upload {{filename}}",
        warnings: {
          STUDENT_NOT_FOUND: "Student not found",
          TASK_NOT_FOUND:
            "A scheduled call task could not be found for this student",
          CASE_NOT_FOUND: "Case not found for this student",
          INTERNAL_ERROR:
            "Failed to update NG list for this student due to a system error",

          INVALID_CSV: "Invalid CSV file",
          PHONE_NUMBER_INVALID: "Invalid phone number",
          PHONE_NUMBER_DUPLICATE: "Duplicate phone number",
          EMAIL_INVALID: "Invalid email",
          NO_CALL_REQUIRED: '"No call" value is required',
          NO_CALL_INVALID: 'Invalid "No call" value — use True or False',
          PHONE_OR_EMAIL_REQUIRED: "Phone number or email is required",
          EMAIL_DUPLICATE: "Duplicate email in file",
          SERVER_CHECK_FAILED: "Server check failed. Please try again.",
          WRITE_FAILED: "Failed to update this student",
        },
        formatCard: {
          title: "CSV Format",
          description:
            "Upload a CSV with the following fields. At least one of Phone number or Email is required per row.",
          downloadTemplate: "Download template",
        },
        noCallAction: {
          add: "Add",
          remove: "Remove",
        },
        columns: {
          row: "Row",
          phone: "Phone number",
          email: "Email",
          noCall: "No call",
          status: "Status",
          details: "Details",
        },
        status: {
          ready: "Ready",
          no_change: "No change",
          not_found: "Not found",
          invalid: "Invalid",
          success: "Done",
          error: "Error",
        },
        preview: {
          readyCount: "{{count}} student(s) ready to process",
          errorCount: "{{count}} row(s) with errors",
          downloadErrors: "Download errors",
          processButton: "Process",
        },
        checking: {
          progress: "Verifying {{completed}} of {{total}} records...",
        },
        importing: {
          progress: "Processing {{completed}} of {{total}}...",
          complete: "Import complete",
          summary:
            "{{success}} student(s) updated successfully, {{errors}} error(s)",
          importAnother: "Import another file",
        },
      },
    },
    errors: {
      errorPage: {
        goBack: "Go back to calliope.co.jp",
        notFoundError: "Page not found",
        notFoundDescription: "The page you are looking for was not found.",
        unexpectedError: "Unexpected error",
        unexpectedErrorDescription: "Please log out and log in again. ",
      },
      form: {
        required: "{{fieldName}} is required",
        wrongDate: "Please set a correct date",
        unknown: "{{fieldName}} is invalid",
        validStartDateTime: "{{fieldName}} needs to be a future date and time",
        scheduledCallDateTimeWithinBounds:
          "{{fieldName}} needs to be within {{months}} months in the future",
      },
      login: {
        passwordFormat: "Incorrect password format.",
        emailFormat: "Incorrect email format.",
        userNotFoundOrUnauthorized: "Incorrect user or password",
        unknownError: "Something went wrong",
        passwordAttemptsExceeded: "Password attempts exceeded",
      },
      resetPassword: {
        unknownErrorRequest: "Something went wrong. Please try again later.",
        unknownErrorConfirm: ["Something went wrong. Please try again later."],
        LimitExceededException:
          "You have exceeded the limit of password reset attempts.",
        UserNotFoundException: "Email not found",
        NotAuthorizedException:
          "Not authorized. Contact your manager / support team.",
        mismatchingPassword: "Passwords do not match",
        notAuthorized: [
          "You are not authorized to reset your password.",
          "Please contact your manager / support team.",
        ],
        expiredCode: [
          "This password reset link has expired for your security.",
          "Please return to the login page and request a new password reset link.",
        ],
        codeMismatch: [
          "Invalid Reset Code.",
          "This can happen if you've opened an old email message or if the code was mistyped. Please check your inbox for our most recent email (sent within the last few minutes) and try again.",
        ],
        userNotFound: [
          "We couldn't find an account with this email address.",
          "Please verify you've entered the correct email address. Alternatively, please contact your manager / support team for assistance.",
        ],
      },
      callPanel: {
        nextContactError: "Failed to switch to the next contact",
        callError: "Failed to make call",
        answerCallError: "Failed to answer call",
        skipCallError: "Failed to skip call",
        endCallError: "Failed to end call",
        resumeCallError: "Failed to resume call",
        holdCallError: "Failed to hold call",
        muteCallError: "Failed to mute call",
        unmuteCallError: "Failed to unmute call",
        statusUpdateError: "Failed to update status",
      },
      callResult: {
        submitError: "Failed to submit call result",
      },
    },
  },
} as const

// A recursive type that reflects the nested structure of the translations... isn't TS crazy? :)
type NestedTranslations<T> = {
  [K in keyof T]: T[K] extends object ? NestedTranslations<T[K]> : string
}

// Type to be used by other language files, English being the reference
export type Translations = NestedTranslations<typeof en>
